import { AfterViewInit, Component, ElementRef, Input, OnInit} from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';

@Component({
  selector: 'cbic-link',
  templateUrl: './link.component.html'
})
export class CbicLinkComponent implements OnInit, AfterViewInit{
  @Input() linkEn?:string | null | undefined = "";
  @Input() linkHi?:string | null | undefined = "";
  @Input() linkTextEn?:string | null | undefined = "";
  @Input() linkTextHi?:string | null | undefined = "";
  @Input() target? = "";
  @Input() iconClass? = "";
  link = "";

  constructor(private changeLnService: ChangeLanguageService,
    private childRef: ElementRef
    ){  }

  ngAfterViewInit(): void {
    const children = this.childRef.nativeElement.children;
    if(children.length > 1){
      children[0].append(children[1]);
    }
  }

  getLink(): string{
    let link = this.linkEn;
    if(this.changeLnService.getLanguage() === 'hi' && this.linkHi){
      link = this.linkHi;
    }
    if(link!.toLowerCase().startsWith("contentrepo")){
      if(link!.toLowerCase().endsWith("pdf")){
        link = `/content/pdf/${link}`;
      }
    }
    return link ?? "";
  }

  getText(): string{
    let linkText = this.linkTextEn;
    if(this.changeLnService.getLanguage() === 'hi' && this.linkTextHi){
      linkText = this.linkTextHi;
    }
    return linkText ?? "";
  }

  ngOnInit(): void {
      this.link = this.getLink();
  }
}
